"use client";

import styled from "@emotion/styled";

export const StyledSvg = styled.svg`
  transition: fill 0.2s;
`;
